import Content from "@/components/Content.tsx";
import Header from "@/Header.tsx";
import User_RecentMatches from "@/user/User_RecentMatches.tsx";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/profile/recent-matches')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header />
        <Content>
            <User_RecentMatches />
        </Content>
    </>
}
